import { useGlobals } from 'hooks/useGlobals';
import { TComboFeature } from './types';

const useCompanyData = () => {
  const globals = useGlobals();

  const useGetComboFeature = (comboFeatureSlug: string): TComboFeature =>
    globals?.user?.data?.company?.combo?.products?.filter((feat: TComboFeature) => feat.slug === comboFeatureSlug)[0];

  return { useGetComboFeature };
};

export { useCompanyData };
